/* global localStorage */
import ApiService from '@/common/api.service'

import { FECTH_DASHBOARD } from '@/store/actions.type'
import { SET_ERROR, SET_DASHBOARD } from '@/store/mutations.type'

const state = {
    dashboard: {},
    errors: null
}

const getters = {
    getDashboard(state) {
        return state.dashboard
    }
}

const mutations = {
    [SET_ERROR](state, error) {
        state.errors = error
    },
    [SET_DASHBOARD](state, dashboard) {
        state.dashboard = dashboard
        state.errors = {}
    }
}

const actions = {
    [FECTH_DASHBOARD](context, data) {
        if (this.sidebar) {
            return this.getSidebar()
        }
        return new Promise((resolve) => {
            ApiService
            .post('dashboard/db', data)
            .then((data) => {
                context.commit(SET_DASHBOARD, data.data.response)
                resolve(data.data.response)
            })
            .catch((data) => {
                context.commit(SET_ERROR, data)
            })
        })
    }
}

export default {
    state,
    mutations,
    getters,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/dashboard.js